<template>
  <IziGrid class="questions">
    <IziCol>
      <IziGrid>
        <IziCol
          v-for="(question, index) of listQuestions"
          :key="index"
          @click="selectQuestion(question, index)"
        >
          <IziCard class="question-name">
            <IziGrid>
              <IziCol :class="`card-question-${index}`">
                <CardQuestion :question="question" :index="index" />
              </IziCol>
              <IziCol>
                <IziGrid>
                  <IziCol xl="10" lg="10" md="10">
                    <IziGrid>
                      <IziCol xl="7" lg="12" md="7" class="col-select-seconds">
                        Seconds to answers:
                        <Dropdown
                          class="select-seconds"
                          v-model="question.secondsToAnswer"
                          :options="seconds"
                        />
                        <!-- <IziInput v-model:value="question.secondsToAnswer" /> -->
                      </IziCol>
                      <IziCol
                        xl="5"
                        lg="12"
                        md="5"
                        class="col-select-point"
                        v-if="checkChallengeType().openEnded"
                      >
                        Max words to input:
                        <Dropdown
                          class="select-seconds"
                          v-model="question.maxWords"
                          :options="maxWords"
                        />
                      </IziCol>
                    </IziGrid>
                  </IziCol>
                  <IziCol xl="2" lg="2" md="2" class="action-card-question">
                    <SettingsQuestion :items="actionCard" label=". . ." />
                  </IziCol>
                </IziGrid>
              </IziCol>
            </IziGrid>
          </IziCard>
        </IziCol>
      </IziGrid>
    </IziCol>
    <IziCol class="col-add-question" col="6">
      <IziButton
        @click="addNewQuestion"
        label="Add new question"
        buttonType="primary"
        theme="text"
        icon="pi pi-plus-circle"
      ></IziButton>
    </IziCol>
  </IziGrid>
</template>
<script lang="ts">
import { computed } from "vue";
import Base from "../../base/Base.vue";
import { Question } from "../../../model/Question.model";
import { Options } from "vue-class-component";
import CardQuestion from "./cardQuestion/CardQuestion.vue";
import SettingsQuestion from "./settingsQuestion/SettingsQuestion.vue";
import { ChallengeType } from "../../../enum/challenge.type";
import { ChallengeSettings } from "../../../model/ChallengeSettings.model";
import ChallengeService from "../../../services/challenge.service";
import { take } from "rxjs/operators";
import GamesService from "../../../services/games.service";
@Options({
  components: {
    CardQuestion,
    SettingsQuestion
  },
  props: ["questions"]
})
export default class ListQuestions extends Base {
  public settingsChallenge = computed<ChallengeSettings>(
    () => this.store.getters.getChallengeSettingSelected
  ).value;
  public elementRef: any;
  maxQuestion = 60;
  // secondsToAnswer = 10;
  public listQuestions: Question[] = [
    {
      name: "What do you want to ask",
      answers: this.checkTypeAnswer(),
      image: "",
      maxWords: 200,
      secondsToAnswer: 10,
      correctAnswer: "answer",
      hashtag: ""
    }
  ];
  seconds = [10, 20, 30];
  maxWords = [100, 200, 300];
  mounted() {
    this.elementRef = this.$el as HTMLElement;
    if(this.settingsChallenge.name.toLowerCase() === ChallengeType.random) {
      this.getRamdomQuestion();
    }
  }
  
  created() {
    // this.getSecondsToAnswer();
    this.$emit("update:questions", this.listQuestions);
    ChallengeService.setQuestion(this.listQuestions[0], 0);
  }

  // getSecondsToAnswer() {
  //   const {name, settings} = this.settingsChallenge;
  //   const typeChallenge = this.settingsChallenge.name;
  //   const timer = settings.find(s => s.name.toLowerCase() === 'timer') as any;
  //   if(name.toLowerCase() !== ChallengeType.random) {}
  //   const {secondQuestion, totalTime} = timer?.data;
  //   const totalQuestion = (totalTime * 60) / 10;
  //   console.log(totalQuestion);
  // }

  getRamdomQuestion() {
    return new Promise(resolve => {
      GamesService.randomQuestion(this.settingsChallenge).subscribe((question: any) => {
        delete question._id;
        resolve(question);
      })
    }).then(q => this.listQuestions = q as any);
  }

  public checkChallengeType() {
    const name = this.settingsChallenge.name.toLowerCase();
    return {
      quiz: name === ChallengeType.quiz,
      poll: name === ChallengeType.poll,
      openEnded: name === ChallengeType.openEnded,
      random: name === ChallengeType.random
    };
  }

  public removeCardQuestion(index: any) {
    if (this.listQuestions.length !== 1) {
      this.listQuestions.splice(index, 1);
      this.updateQuestions();
    }
  }
  public addNewQuestion() {
    const newQuestion: Question = {
      name: "",
      answers: this.checkTypeAnswer(),
      image: "",
      maxWords: 200,
      secondsToAnswer: 10,
      correctAnswer: "",
      hashtag: ""
    };
    this.newQuestion(newQuestion);
  }
  public updateQuestions() {
    this.$emit("update:questions", this.listQuestions);
  }
  checkTypeAnswer() {
    const name = this.settingsChallenge.name.toLowerCase();
    if (name.toLowerCase() === ChallengeType.openEnded) {
      return [{ name: ""}];
    } else {
      return [
        { name: "answer"},
        { name: ""}
      ];
    }
  }

  public selectQuestion(question: Question, index: any) {
    ChallengeService.setQuestion(question, index);
  }

  actionCard = [
    {
      label: "Duplicate",
      icon: "pi pi-copy",
      command: () => {
        ChallengeService.questionSub.pipe(take(1)).subscribe(question => {
          this.newQuestion(question);
        });
      }
    },
    {
      label: "Remove",
      icon: "pi pi-trash",
      command: () => {
        ChallengeService.questionSub.pipe(take(1)).subscribe(question => {
          const index = this.listQuestions.findIndex(q => q === question);
          this.removeCardQuestion(index);
        });
      }
    }
  ];

  newQuestion(question: Question) {
    return new Promise(resolve => {
      const newQuestion = JSON.stringify(question);
      this.listQuestions.push(JSON.parse(newQuestion));
      const questionScroll = document.getElementsByClassName(
        `card-question-${this.listQuestions.length - 1}`
      );
      resolve(questionScroll);
    }).then((questions: any) => {
      this.updateQuestions();
      const question = questions[0] as HTMLElement;
      question.scrollIntoView({ behavior: "smooth" });
    });
  }
}
</script>
